export default class AwaitRetryError extends Error {
  name = 'AwaitRetryError';

  constructor(readonly message = 'Await Before Retry Error') {
    super(message);
  }
}
